import m, { createElement as vn, forwardRef as hn, useState as Mt, useEffect as gn } from "react";
import k from "styled-components";
import { addWeeks as bn, addDays as Wt, subWeeks as xn, isSameDay as Ee, format as te, isToday as Ft, startOfWeek as ot, isSameYear as yn } from "date-fns";
function Sn(t) {
  return t && t.__esModule && Object.prototype.hasOwnProperty.call(t, "default") ? t.default : t;
}
var De = { exports: {} }, Se = {};
/**
 * @license React
 * react-jsx-runtime.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var lt;
function wn() {
  if (lt) return Se;
  lt = 1;
  var t = m, n = Symbol.for("react.element"), r = Symbol.for("react.fragment"), i = Object.prototype.hasOwnProperty, s = t.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, l = { key: !0, ref: !0, __self: !0, __source: !0 };
  function u(o, d, C) {
    var v, p = {}, x = null, h = null;
    C !== void 0 && (x = "" + C), d.key !== void 0 && (x = "" + d.key), d.ref !== void 0 && (h = d.ref);
    for (v in d) i.call(d, v) && !l.hasOwnProperty(v) && (p[v] = d[v]);
    if (o && o.defaultProps) for (v in d = o.defaultProps, d) p[v] === void 0 && (p[v] = d[v]);
    return { $$typeof: n, type: o, key: x, ref: h, props: p, _owner: s.current };
  }
  return Se.Fragment = r, Se.jsx = u, Se.jsxs = u, Se;
}
var we = {};
/**
 * @license React
 * react-jsx-runtime.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var st;
function En() {
  return st || (st = 1, process.env.NODE_ENV !== "production" && function() {
    var t = m, n = Symbol.for("react.element"), r = Symbol.for("react.portal"), i = Symbol.for("react.fragment"), s = Symbol.for("react.strict_mode"), l = Symbol.for("react.profiler"), u = Symbol.for("react.provider"), o = Symbol.for("react.context"), d = Symbol.for("react.forward_ref"), C = Symbol.for("react.suspense"), v = Symbol.for("react.suspense_list"), p = Symbol.for("react.memo"), x = Symbol.for("react.lazy"), h = Symbol.for("react.offscreen"), $ = Symbol.iterator, L = "@@iterator";
    function V(e) {
      if (e === null || typeof e != "object")
        return null;
      var a = $ && e[$] || e[L];
      return typeof a == "function" ? a : null;
    }
    var _ = t.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
    function y(e) {
      {
        for (var a = arguments.length, c = new Array(a > 1 ? a - 1 : 0), f = 1; f < a; f++)
          c[f - 1] = arguments[f];
        H("error", e, c);
      }
    }
    function H(e, a, c) {
      {
        var f = _.ReactDebugCurrentFrame, w = f.getStackAddendum();
        w !== "" && (a += "%s", c = c.concat([w]));
        var T = c.map(function(b) {
          return String(b);
        });
        T.unshift("Warning: " + a), Function.prototype.apply.call(console[e], console, T);
      }
    }
    var q = !1, U = !1, ne = !1, K = !1, de = !1, B;
    B = Symbol.for("react.module.reference");
    function fe(e) {
      return !!(typeof e == "string" || typeof e == "function" || e === i || e === l || de || e === s || e === C || e === v || K || e === h || q || U || ne || typeof e == "object" && e !== null && (e.$$typeof === x || e.$$typeof === p || e.$$typeof === u || e.$$typeof === o || e.$$typeof === d || // This needs to include all possible module reference object
      // types supported by any Flight configuration anywhere since
      // we don't know which Flight build this will end up being used
      // with.
      e.$$typeof === B || e.getModuleId !== void 0));
    }
    function pe(e, a, c) {
      var f = e.displayName;
      if (f)
        return f;
      var w = a.displayName || a.name || "";
      return w !== "" ? c + "(" + w + ")" : c;
    }
    function X(e) {
      return e.displayName || "Context";
    }
    function I(e) {
      if (e == null)
        return null;
      if (typeof e.tag == "number" && y("Received an unexpected object in getComponentNameFromType(). This is likely a bug in React. Please file an issue."), typeof e == "function")
        return e.displayName || e.name || null;
      if (typeof e == "string")
        return e;
      switch (e) {
        case i:
          return "Fragment";
        case r:
          return "Portal";
        case l:
          return "Profiler";
        case s:
          return "StrictMode";
        case C:
          return "Suspense";
        case v:
          return "SuspenseList";
      }
      if (typeof e == "object")
        switch (e.$$typeof) {
          case o:
            var a = e;
            return X(a) + ".Consumer";
          case u:
            var c = e;
            return X(c._context) + ".Provider";
          case d:
            return pe(e, e.render, "ForwardRef");
          case p:
            var f = e.displayName || null;
            return f !== null ? f : I(e.type) || "Memo";
          case x: {
            var w = e, T = w._payload, b = w._init;
            try {
              return I(b(T));
            } catch {
              return null;
            }
          }
        }
      return null;
    }
    var P = Object.assign, z = 0, F, Y, me, _e, Re, ve, he;
    function ke() {
    }
    ke.__reactDisabledLog = !0;
    function Ie() {
      {
        if (z === 0) {
          F = console.log, Y = console.info, me = console.warn, _e = console.error, Re = console.group, ve = console.groupCollapsed, he = console.groupEnd;
          var e = {
            configurable: !0,
            enumerable: !0,
            value: ke,
            writable: !0
          };
          Object.defineProperties(console, {
            info: e,
            log: e,
            warn: e,
            error: e,
            group: e,
            groupCollapsed: e,
            groupEnd: e
          });
        }
        z++;
      }
    }
    function ge() {
      {
        if (z--, z === 0) {
          var e = {
            configurable: !0,
            enumerable: !0,
            writable: !0
          };
          Object.defineProperties(console, {
            log: P({}, e, {
              value: F
            }),
            info: P({}, e, {
              value: Y
            }),
            warn: P({}, e, {
              value: me
            }),
            error: P({}, e, {
              value: _e
            }),
            group: P({}, e, {
              value: Re
            }),
            groupCollapsed: P({}, e, {
              value: ve
            }),
            groupEnd: P({}, e, {
              value: he
            })
          });
        }
        z < 0 && y("disabledDepth fell below zero. This is a bug in React. Please file an issue.");
      }
    }
    var je = _.ReactCurrentDispatcher, le;
    function J(e, a, c) {
      {
        if (le === void 0)
          try {
            throw Error();
          } catch (w) {
            var f = w.stack.trim().match(/\n( *(at )?)/);
            le = f && f[1] || "";
          }
        return `
` + le + e;
      }
    }
    var be = !1, re;
    {
      var Oe = typeof WeakMap == "function" ? WeakMap : Map;
      re = new Oe();
    }
    function xe(e, a) {
      if (!e || be)
        return "";
      {
        var c = re.get(e);
        if (c !== void 0)
          return c;
      }
      var f;
      be = !0;
      var w = Error.prepareStackTrace;
      Error.prepareStackTrace = void 0;
      var T;
      T = je.current, je.current = null, Ie();
      try {
        if (a) {
          var b = function() {
            throw Error();
          };
          if (Object.defineProperty(b.prototype, "props", {
            set: function() {
              throw Error();
            }
          }), typeof Reflect == "object" && Reflect.construct) {
            try {
              Reflect.construct(b, []);
            } catch (A) {
              f = A;
            }
            Reflect.construct(e, [], b);
          } else {
            try {
              b.call();
            } catch (A) {
              f = A;
            }
            e.call(b.prototype);
          }
        } else {
          try {
            throw Error();
          } catch (A) {
            f = A;
          }
          e();
        }
      } catch (A) {
        if (A && f && typeof A.stack == "string") {
          for (var g = A.stack.split(`
`), N = f.stack.split(`
`), j = g.length - 1, O = N.length - 1; j >= 1 && O >= 0 && g[j] !== N[O]; )
            O--;
          for (; j >= 1 && O >= 0; j--, O--)
            if (g[j] !== N[O]) {
              if (j !== 1 || O !== 1)
                do
                  if (j--, O--, O < 0 || g[j] !== N[O]) {
                    var W = `
` + g[j].replace(" at new ", " at ");
                    return e.displayName && W.includes("<anonymous>") && (W = W.replace("<anonymous>", e.displayName)), typeof e == "function" && re.set(e, W), W;
                  }
                while (j >= 1 && O >= 0);
              break;
            }
        }
      } finally {
        be = !1, je.current = T, ge(), Error.prepareStackTrace = w;
      }
      var ue = e ? e.displayName || e.name : "", ae = ue ? J(ue) : "";
      return typeof e == "function" && re.set(e, ae), ae;
    }
    function Ae(e, a, c) {
      return xe(e, !1);
    }
    function $e(e) {
      var a = e.prototype;
      return !!(a && a.isReactComponent);
    }
    function G(e, a, c) {
      if (e == null)
        return "";
      if (typeof e == "function")
        return xe(e, $e(e));
      if (typeof e == "string")
        return J(e);
      switch (e) {
        case C:
          return J("Suspense");
        case v:
          return J("SuspenseList");
      }
      if (typeof e == "object")
        switch (e.$$typeof) {
          case d:
            return Ae(e.render);
          case p:
            return G(e.type, a, c);
          case x: {
            var f = e, w = f._payload, T = f._init;
            try {
              return G(T(w), a, c);
            } catch {
            }
          }
        }
      return "";
    }
    var Z = Object.prototype.hasOwnProperty, se = {}, S = _.ReactDebugCurrentFrame;
    function M(e) {
      if (e) {
        var a = e._owner, c = G(e.type, e._source, a ? a.type : null);
        S.setExtraStackFrame(c);
      } else
        S.setExtraStackFrame(null);
    }
    function ye(e, a, c, f, w) {
      {
        var T = Function.call.bind(Z);
        for (var b in e)
          if (T(e, b)) {
            var g = void 0;
            try {
              if (typeof e[b] != "function") {
                var N = Error((f || "React class") + ": " + c + " type `" + b + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof e[b] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.");
                throw N.name = "Invariant Violation", N;
              }
              g = e[b](a, b, f, c, null, "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED");
            } catch (j) {
              g = j;
            }
            g && !(g instanceof Error) && (M(w), y("%s: type specification of %s `%s` is invalid; the type checker function must return `null` or an `Error` but returned a %s. You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument).", f || "React class", c, b, typeof g), M(null)), g instanceof Error && !(g.message in se) && (se[g.message] = !0, M(w), y("Failed %s type: %s", c, g.message), M(null));
          }
      }
    }
    var qt = Array.isArray;
    function Le(e) {
      return qt(e);
    }
    function Kt(e) {
      {
        var a = typeof Symbol == "function" && Symbol.toStringTag, c = a && e[Symbol.toStringTag] || e.constructor.name || "Object";
        return c;
      }
    }
    function Xt(e) {
      try {
        return Ke(e), !1;
      } catch {
        return !0;
      }
    }
    function Ke(e) {
      return "" + e;
    }
    function Xe(e) {
      if (Xt(e))
        return y("The provided key is an unsupported type %s. This value must be coerced to a string before before using it here.", Kt(e)), Ke(e);
    }
    var Je = _.ReactCurrentOwner, Jt = {
      key: !0,
      ref: !0,
      __self: !0,
      __source: !0
    }, Ge, Ze;
    function Gt(e) {
      if (Z.call(e, "ref")) {
        var a = Object.getOwnPropertyDescriptor(e, "ref").get;
        if (a && a.isReactWarning)
          return !1;
      }
      return e.ref !== void 0;
    }
    function Zt(e) {
      if (Z.call(e, "key")) {
        var a = Object.getOwnPropertyDescriptor(e, "key").get;
        if (a && a.isReactWarning)
          return !1;
      }
      return e.key !== void 0;
    }
    function Qt(e, a) {
      typeof e.ref == "string" && Je.current;
    }
    function en(e, a) {
      {
        var c = function() {
          Ge || (Ge = !0, y("%s: `key` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", a));
        };
        c.isReactWarning = !0, Object.defineProperty(e, "key", {
          get: c,
          configurable: !0
        });
      }
    }
    function tn(e, a) {
      {
        var c = function() {
          Ze || (Ze = !0, y("%s: `ref` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", a));
        };
        c.isReactWarning = !0, Object.defineProperty(e, "ref", {
          get: c,
          configurable: !0
        });
      }
    }
    var nn = function(e, a, c, f, w, T, b) {
      var g = {
        // This tag allows us to uniquely identify this as a React Element
        $$typeof: n,
        // Built-in properties that belong on the element
        type: e,
        key: a,
        ref: c,
        props: b,
        // Record the component responsible for creating this element.
        _owner: T
      };
      return g._store = {}, Object.defineProperty(g._store, "validated", {
        configurable: !1,
        enumerable: !1,
        writable: !0,
        value: !1
      }), Object.defineProperty(g, "_self", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: f
      }), Object.defineProperty(g, "_source", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: w
      }), Object.freeze && (Object.freeze(g.props), Object.freeze(g)), g;
    };
    function rn(e, a, c, f, w) {
      {
        var T, b = {}, g = null, N = null;
        c !== void 0 && (Xe(c), g = "" + c), Zt(a) && (Xe(a.key), g = "" + a.key), Gt(a) && (N = a.ref, Qt(a, w));
        for (T in a)
          Z.call(a, T) && !Jt.hasOwnProperty(T) && (b[T] = a[T]);
        if (e && e.defaultProps) {
          var j = e.defaultProps;
          for (T in j)
            b[T] === void 0 && (b[T] = j[T]);
        }
        if (g || N) {
          var O = typeof e == "function" ? e.displayName || e.name || "Unknown" : e;
          g && en(b, O), N && tn(b, O);
        }
        return nn(e, g, N, w, f, Je.current, b);
      }
    }
    var Me = _.ReactCurrentOwner, Qe = _.ReactDebugCurrentFrame;
    function ce(e) {
      if (e) {
        var a = e._owner, c = G(e.type, e._source, a ? a.type : null);
        Qe.setExtraStackFrame(c);
      } else
        Qe.setExtraStackFrame(null);
    }
    var We;
    We = !1;
    function Fe(e) {
      return typeof e == "object" && e !== null && e.$$typeof === n;
    }
    function et() {
      {
        if (Me.current) {
          var e = I(Me.current.type);
          if (e)
            return `

Check the render method of \`` + e + "`.";
        }
        return "";
      }
    }
    function an(e) {
      return "";
    }
    var tt = {};
    function on(e) {
      {
        var a = et();
        if (!a) {
          var c = typeof e == "string" ? e : e.displayName || e.name;
          c && (a = `

Check the top-level render call using <` + c + ">.");
        }
        return a;
      }
    }
    function nt(e, a) {
      {
        if (!e._store || e._store.validated || e.key != null)
          return;
        e._store.validated = !0;
        var c = on(a);
        if (tt[c])
          return;
        tt[c] = !0;
        var f = "";
        e && e._owner && e._owner !== Me.current && (f = " It was passed a child from " + I(e._owner.type) + "."), ce(e), y('Each child in a list should have a unique "key" prop.%s%s See https://reactjs.org/link/warning-keys for more information.', c, f), ce(null);
      }
    }
    function rt(e, a) {
      {
        if (typeof e != "object")
          return;
        if (Le(e))
          for (var c = 0; c < e.length; c++) {
            var f = e[c];
            Fe(f) && nt(f, a);
          }
        else if (Fe(e))
          e._store && (e._store.validated = !0);
        else if (e) {
          var w = V(e);
          if (typeof w == "function" && w !== e.entries)
            for (var T = w.call(e), b; !(b = T.next()).done; )
              Fe(b.value) && nt(b.value, a);
        }
      }
    }
    function ln(e) {
      {
        var a = e.type;
        if (a == null || typeof a == "string")
          return;
        var c;
        if (typeof a == "function")
          c = a.propTypes;
        else if (typeof a == "object" && (a.$$typeof === d || // Note: Memo only checks outer props here.
        // Inner props are checked in the reconciler.
        a.$$typeof === p))
          c = a.propTypes;
        else
          return;
        if (c) {
          var f = I(a);
          ye(c, e.props, "prop", f, e);
        } else if (a.PropTypes !== void 0 && !We) {
          We = !0;
          var w = I(a);
          y("Component %s declared `PropTypes` instead of `propTypes`. Did you misspell the property assignment?", w || "Unknown");
        }
        typeof a.getDefaultProps == "function" && !a.getDefaultProps.isReactClassApproved && y("getDefaultProps is only used on classic React.createClass definitions. Use a static property named `defaultProps` instead.");
      }
    }
    function sn(e) {
      {
        for (var a = Object.keys(e.props), c = 0; c < a.length; c++) {
          var f = a[c];
          if (f !== "children" && f !== "key") {
            ce(e), y("Invalid prop `%s` supplied to `React.Fragment`. React.Fragment can only have `key` and `children` props.", f), ce(null);
            break;
          }
        }
        e.ref !== null && (ce(e), y("Invalid attribute `ref` supplied to `React.Fragment`."), ce(null));
      }
    }
    var at = {};
    function it(e, a, c, f, w, T) {
      {
        var b = fe(e);
        if (!b) {
          var g = "";
          (e === void 0 || typeof e == "object" && e !== null && Object.keys(e).length === 0) && (g += " You likely forgot to export your component from the file it's defined in, or you might have mixed up default and named imports.");
          var N = an();
          N ? g += N : g += et();
          var j;
          e === null ? j = "null" : Le(e) ? j = "array" : e !== void 0 && e.$$typeof === n ? (j = "<" + (I(e.type) || "Unknown") + " />", g = " Did you accidentally export a JSX literal instead of a component?") : j = typeof e, y("React.jsx: type is invalid -- expected a string (for built-in components) or a class/function (for composite components) but got: %s.%s", j, g);
        }
        var O = rn(e, a, c, w, T);
        if (O == null)
          return O;
        if (b) {
          var W = a.children;
          if (W !== void 0)
            if (f)
              if (Le(W)) {
                for (var ue = 0; ue < W.length; ue++)
                  rt(W[ue], e);
                Object.freeze && Object.freeze(W);
              } else
                y("React.jsx: Static children should always be an array. You are likely explicitly calling React.jsxs or React.jsxDEV. Use the Babel transform instead.");
            else
              rt(W, e);
        }
        if (Z.call(a, "key")) {
          var ae = I(e), A = Object.keys(a).filter(function(mn) {
            return mn !== "key";
          }), Ue = A.length > 0 ? "{key: someKey, " + A.join(": ..., ") + ": ...}" : "{key: someKey}";
          if (!at[ae + Ue]) {
            var pn = A.length > 0 ? "{" + A.join(": ..., ") + ": ...}" : "{}";
            y(`A props object containing a "key" prop is being spread into JSX:
  let props = %s;
  <%s {...props} />
React keys must be passed directly to JSX without using spread:
  let props = %s;
  <%s key={someKey} {...props} />`, Ue, ae, pn, ae), at[ae + Ue] = !0;
          }
        }
        return e === i ? sn(O) : ln(O), O;
      }
    }
    function cn(e, a, c) {
      return it(e, a, c, !0);
    }
    function un(e, a, c) {
      return it(e, a, c, !1);
    }
    var dn = un, fn = cn;
    we.Fragment = i, we.jsx = dn, we.jsxs = fn;
  }()), we;
}
var ct;
function Cn() {
  return ct || (ct = 1, process.env.NODE_ENV === "production" ? De.exports = wn() : De.exports = En()), De.exports;
}
var E = Cn();
const Tn = "useandom-26T198340PX75pxJACKVERYMINDBUSHWOLF_GQZbfghjklqvwyzrict";
let Ve = (t = 21) => {
  let n = "", r = crypto.getRandomValues(new Uint8Array(t |= 0));
  for (; t--; )
    n += Tn[r[t] & 63];
  return n;
};
var Be = { exports: {} };
/*!
	Copyright (c) 2018 Jed Watson.
	Licensed under the MIT License (MIT), see
	http://jedwatson.github.io/classnames
*/
var ut;
function _n() {
  return ut || (ut = 1, function(t) {
    (function() {
      var n = {}.hasOwnProperty;
      function r() {
        for (var l = "", u = 0; u < arguments.length; u++) {
          var o = arguments[u];
          o && (l = s(l, i(o)));
        }
        return l;
      }
      function i(l) {
        if (typeof l == "string" || typeof l == "number")
          return l;
        if (typeof l != "object")
          return "";
        if (Array.isArray(l))
          return r.apply(null, l);
        if (l.toString !== Object.prototype.toString && !l.toString.toString().includes("[native code]"))
          return l.toString();
        var u = "";
        for (var o in l)
          n.call(l, o) && l[o] && (u = s(u, o));
        return u;
      }
      function s(l, u) {
        return u ? l ? l + " " + u : l + u : l;
      }
      t.exports ? (r.default = r, t.exports = r) : window.classNames = r;
    })();
  }(Be)), Be.exports;
}
var Rn = _n();
const Ce = /* @__PURE__ */ Sn(Rn), Pe = "typography";
class Ut {
  constructor(n = "") {
    this.prefix = "", this.fromTextStyleName = (r) => {
      const [i, s] = r.split(".");
      return {
        typographyClassName: this.generateClassNames(i.toLowerCase().replace("regular", ""), s.toLowerCase(), i.includes("Regular")),
        textStyleGroup: i,
        textStyleSize: s
      };
    }, this.generateClassNames = (r, i, s) => {
      const l = `${this.prefix}${Pe}`, u = s ? ` ${l}-regular` : "", o = i ? `-${i}` : "";
      return `${l}-${r}${o}${u}`;
    }, this.generateContextClassNames = (r, i) => {
      const s = `${this.prefix}${Pe}`;
      return `${s}-${r} ${s}-${i}`;
    }, this.prefix = n;
  }
  get TypographyRoot() {
    return `${this.Context.TypeScale.Desktop}`;
  }
  get Context() {
    const n = this.generateClassNames.bind(this);
    return {
      opticalEdgeAlign: `${this.prefix}${Pe}-margin-compensation`,
      paragraphSpacing: `${this.prefix}${Pe}-paragraph-spacing`,
      get BaseSize() {
        const r = n.bind(this, "base");
        return {
          base14: r("14"),
          base16: r("16"),
          base20: r("20"),
          base28: r("28"),
          base56: r("56")
        };
      },
      get TypeScale() {
        const r = n.bind(this, "typescale");
        return {
          Auto: r("auto"),
          Desktop: r("desktop"),
          SmallScreen: r("small-screen"),
          LargeScreen: r("large-screen")
        };
      },
      get CharacterSet() {
        const r = n.bind(this, "character-set");
        return {
          LatinCyrillicGreek: r("latin_cyrill_greek"),
          Arabic: r("arabic"),
          ChineseSimplified: r("chinese_simplified"),
          ChineseTraditional: r("chinese_traditional"),
          Hebrew: r("hebrew"),
          Japanese: r("japanese"),
          Korean: r("korean"),
          Thai: r("thai")
        };
      }
    };
  }
  get Display() {
    const n = this.generateClassNames.bind(this, "display");
    return {
      M: n("m"),
      L: n("l"),
      XL: n("xl")
    };
  }
  get DisplayRegular() {
    const n = this.generateClassNames.bind(this, "display");
    return {
      M: n("m", !0),
      L: n("l", !0),
      XL: n("xl", !0)
    };
  }
  get Heading() {
    const n = this.generateClassNames.bind(this, "heading");
    return {
      XS: n("xs"),
      S: n("s"),
      M: n("m"),
      L: n("l"),
      XL: n("xl")
    };
  }
  get HeadingRegular() {
    const n = this.generateClassNames.bind(this, "heading");
    return {
      XS: n("xs", !0),
      S: n("s", !0),
      M: n("m", !0),
      L: n("l", !0),
      XL: n("xl", !0)
    };
  }
  get Statement() {
    const n = this.generateClassNames.bind(this, "statement");
    return {
      M: n("m"),
      L: n("l")
    };
  }
  get Body() {
    const n = this.generateClassNames.bind(this, "body");
    return {
      S: n("s"),
      M: n("m"),
      L: n("l")
    };
  }
  get Label() {
    const n = this.generateClassNames.bind(this, "label");
    return {
      XS: n("xs"),
      S: n("s"),
      M: n("m"),
      L: n("l")
    };
  }
  get LabelRegular() {
    const n = this.generateClassNames.bind(this, "label");
    return {
      XS: n("xs", !0),
      S: n("s", !0),
      M: n("m", !0),
      L: n("l", !0)
    };
  }
  get Caption() {
    const n = this.generateClassNames.bind(this, "caption");
    return {
      S: n("s"),
      M: n("m"),
      L: n("l")
    };
  }
}
new Ut();
const kn = (t) => {
  const {
    prefix: n = "",
    className: r,
    tagName: i = "div",
    textStyle: s = "Body.M",
    colour: l = !0,
    children: u,
    ...o
  } = t, d = new Ut(n), { typographyClassName: C, textStyleGroup: v } = d.fromTextStyleName(s), p = `${n}text`, x = Ce(
    l && p,
    C,
    l && ["Body", "Caption"].includes(v) ? `${p}--lighter` : "",
    r
  ), h = i || "div";
  return /* @__PURE__ */ E.jsx(h, { ...o, className: x, children: u });
};
var jn = kn, ee = jn, ie = function() {
  return ie = Object.assign || function(n) {
    for (var r, i = 1, s = arguments.length; i < s; i++) {
      r = arguments[i];
      for (var l in r) Object.prototype.hasOwnProperty.call(r, l) && (n[l] = r[l]);
    }
    return n;
  }, ie.apply(this, arguments);
};
function D(t, n) {
  return Object.defineProperty ? Object.defineProperty(t, "raw", { value: n }) : t.raw = n, t;
}
const oe = {
  tabletPortraitUp: "600px",
  tabletLandscapeUp: "900px"
}, On = "rgb(var(--colour-neutral-1, 255, 255, 255))", $n = "rgb(var(--colour-neutral-3, 223, 223, 223))", Dn = "rgb(var(--colour-neutral-4, 204, 204, 204))", Pn = "rgb(var(--colour-text-and-icon-1, 17, 17, 17))", Nn = "rgb(var(--colour-text-and-icon-2, 72, 72, 72))", In = "rgb(var(--colour-text-and-icon-3, 118, 118, 118))", An = "rgb(var(--colour-interactive-emphasised-bg-default, 0, 88, 163))", Ln = "rgb(var(--colour-interactive-emphasised-bg-hover, 0, 79, 147))", Q = {
  colourNeutral1: On,
  colourNeutral3: $n,
  colourNeutral4: Dn,
  colourTextAndIcon1: Pn,
  colourTextAndIcon2: Nn,
  colourTextAndIcon3: In,
  colourInteractiveEmphasisedBgDefault: An,
  colourInteractiveEmphasisedBgHover: Ln
}, R = {
  static: {
    green: "#0dcb00"
  },
  text: {
    default: Q.colourTextAndIcon2,
    dark: Q.colourTextAndIcon1,
    disabled: Q.colourTextAndIcon3
  },
  background: {
    default: Q.colourNeutral1
  },
  interactive: {
    default: Q.colourNeutral3,
    defaultHover: Q.colourNeutral4,
    emphasised: Q.colourInteractiveEmphasisedBgDefault,
    emphasisedHover: Q.colourInteractiveEmphasisedBgHover,
    borderEmphasised: "rgba(0, 88, 163, 0.61)"
  }
};
var Mn = k.div(dt || (dt = D([`
  display: flex;
  justify-content: space-between;
  padding-bottom: 10px;
  color: `, `;
  margin: 0;
`], [`
  display: flex;
  justify-content: space-between;
  padding-bottom: 10px;
  color: `, `;
  margin: 0;
`])), R.text.default), Wn = k.abbr(ft || (ft = D([`
  font-size: 12px;
  line-height: 16px;
  text-align: center;
  width: 38px;
  user-select: none;
  text-decoration: none;

  @media (min-width: `, `) {
    width: 64px;
  }
`], [`
  font-size: 12px;
  line-height: 16px;
  text-align: center;
  width: 38px;
  user-select: none;
  text-decoration: none;

  @media (min-width: `, `) {
    width: 64px;
  }
`])), oe.tabletPortraitUp), Fn = function(t) {
  var n = t.days;
  return m.createElement(Mn, { "aria-hidden": "true" }, n.map(function(r) {
    return m.createElement(Wn, { key: r.name, title: r.title }, r.name);
  }));
}, dt, ft;
const Un = ({
  prefix: t = "",
  className: n,
  viewBox: r = "0 0 24 24",
  ariaHidden: i = !0,
  children: s,
  ...l
}) => /* @__PURE__ */ E.jsx(
  "svg",
  {
    viewBox: r,
    focusable: "false",
    width: "24",
    height: "24",
    ...l,
    "aria-hidden": i,
    className: `${t}svg-icon${n ? ` ${n}` : ""}`,
    children: s
  }
), Bn = (t) => {
  const {
    prefix: n = "",
    viewBox: r = "0 0 24 24",
    paths: i,
    className: s,
    modifier: l,
    ariaHidden: u = !0,
    ...o
  } = t, d = Ce(s, l && `${n}svg-icon--${l}`);
  return i ? /* @__PURE__ */ E.jsx(
    Un,
    {
      viewBox: r,
      prefix: n,
      ...o,
      className: d,
      ariaHidden: u,
      children: i().map((C, v) => m.cloneElement(C, { key: v }))
    }
  ) : null;
};
var zn = Bn, Bt = zn;
const Yn = [{ tag: "path", att: { d: "M11.0036 14.2509h2v-6h-2v6zm1 1.5c-.6904 0-1.25.5596-1.25 1.25 0 .6903.5596 1.25 1.25 1.25.6903 0 1.25-.5597 1.25-1.25 0-.6904-.5597-1.25-1.25-1.25z" } }, { tag: "path", att: { "fill-rule": "evenodd", "clip-rule": "evenodd", d: "m1.1152 20.5351 10-19h1.7699l10 19-.8849 1.4658h-20l-.885-1.4658zm2.5413-.5342h16.6873l-8.3436-15.853-8.3437 15.853z" } }];
function pt(t) {
  return t.replace(/-([a-z])/g, (n, r) => r.toUpperCase());
}
function Vn(t) {
  return Object.entries(t).reduce((n, [r, i]) => (r === "style" && typeof i == "string" ? n.style = i.split(";").reduce((s, l) => {
    const [u, o] = l.split(":");
    return u && o && (s[pt(u.trim())] = o.trim()), s;
  }, {}) : n[pt(r)] = i, n), {});
}
function Te(t) {
  if (t)
    return t.map(
      (n) => vn(n.tag, Vn(n.att), Te(n.nds))
    );
}
var Hn = () => Te(Yn);
const qn = [
  "primary",
  "emphasised",
  "secondary",
  "tertiary"
], zt = hn(
  (t, n) => {
    const {
      href: r = "",
      newWindow: i = !1,
      loadingSrText: s = "Loading…",
      ssrIcon: l,
      iconOnly: u = !1,
      prefix: o = "",
      htmlType: d = "button",
      disabled: C = !1,
      className: v = "",
      onClick: p,
      text: x = "",
      type: h = "secondary",
      expanding: $ = !1,
      loading: L = !1,
      iconPosition: V = "leading",
      fluid: _ = !1,
      inverseTheme: y = !1,
      children: H,
      expandedOnTouchDevice: q = !1,
      size: U = "medium",
      staticColour: ne = !1,
      ...K
    } = t, de = (Y) => {
      if (C || L || Y.key !== " ")
        return;
      Y.target.click();
    };
    let B = h || "secondary";
    u && l && (B = `icon-${B}`), y && h !== "danger" && h !== "plain" && h !== "image-overlay" && qn.indexOf(h) > -1 && (B = `${B}-inverse`);
    const fe = Ce(`${o}btn__inner`), pe = `${o}btn__icon`, X = h === "danger" ? Hn : l, I = X ? /* @__PURE__ */ E.jsx(Bt, { className: pe, prefix: o, paths: X }) : null, P = Ce(
      `${o}btn`,
      L && `${o}btn--loading`,
      U !== "medium" && `${o}btn--${U}`,
      !u && X && V && `${o}${V}-icon`,
      h && `${o}btn--${B}`,
      _ && !u && `${o}btn--fluid`,
      $ && `${o}btn--expanding`,
      $ && q && `${o}btn--touch-device-expanded`,
      ne && `${o}btn--static-colour`,
      v
    ), z = (Y) => {
      if (L || C) {
        Y.stopPropagation();
        return;
      }
      p && typeof p == "function" && p(Y);
    }, F = /* @__PURE__ */ E.jsxs("span", { className: fe, children: [
      I,
      x && /* @__PURE__ */ E.jsx("span", { className: `${o}btn__label`, children: x }) || null,
      !L && H || null,
      L && /* @__PURE__ */ E.jsx("span", { className: `${o}btn__loader`, children: s }) || null
    ] });
    return r ? /* @__PURE__ */ E.jsx(
      "a",
      {
        ref: n,
        className: P,
        "aria-disabled": L ? !0 : void 0,
        onClick: z,
        onKeyUp: de,
        href: C ? void 0 : r,
        target: i ? "_blank" : void 0,
        rel: i ? "noreferrer" : void 0,
        ...K,
        children: F
      }
    ) : /* @__PURE__ */ E.jsx(
      "button",
      {
        ref: n,
        className: P,
        disabled: C,
        type: d,
        onClick: z,
        ...K,
        children: F
      }
    );
  }
);
zt.displayName = "Button";
var Kn = zt, Ne = Kn, Xn = k.div(vt || (vt = D([`
  position: relative;
  margin-top: 8px;
`], [`
  position: relative;
  margin-top: 8px;
`]))), Yt = k(Ne)(ht || (ht = D([`
  &&& {
    .btn__inner {
      font-weight: 400;
      min-height: 2rem;
      height: 2rem;
      padding: 0 14px;
    }
  }
`], [`
  &&& {
    .btn__inner {
      font-weight: 400;
      min-height: 2rem;
      height: 2rem;
      padding: 0 14px;
    }
  }
`]))), Jn = k(Yt)(gt || (gt = D([`
  &&& {
    .btn__inner {
      background: `, `;
      color: `, `;

      &:hover {
        background: `, `;
      }
    }
  }
`], [`
  &&& {
    .btn__inner {
      background: `, `;
      color: `, `;

      &:hover {
        background: `, `;
      }
    }
  }
`])), R.interactive.default, R.text.dark, R.interactive.defaultHover), mt = function(t) {
  var n = t.id, r = t.generatedId, i = t.from, s = t.to, l = t.selected, u = t.selectTimeSlot, o = "".concat(n, "-").concat(r), d = m.useCallback(function() {
    u(n);
  }, [n, u]);
  return m.createElement(Xn, null, l ? m.createElement(
    Yt,
    { id: "timeslot-".concat(o), type: "emphasised", onClick: d, "aria-pressed": l },
    i,
    " - ",
    s
  ) : m.createElement(
    Jn,
    { id: "timeslot-".concat(o), type: "tertiary", onClick: d, "aria-pressed": l },
    i,
    " - ",
    s
  ));
}, vt, ht, gt;
const Gn = (t) => {
  const {
    prefix: n = "",
    label: r = "Label",
    reqText: i,
    htmlFor: s,
    className: l,
    ...u
  } = t;
  return /* @__PURE__ */ E.jsxs("label", { htmlFor: s, className: l, ...u, children: [
    r,
    i && /* @__PURE__ */ E.jsxs("em", { className: `${n}required`, children: [
      " ",
      i
    ] })
  ] });
};
var Zn = Gn, Qn = Zn;
const er = (t) => {
  const {
    id: n,
    prefix: r = "",
    describedById: i,
    value: s,
    name: l = "switchname",
    className: u,
    onChange: o,
    label: d,
    subtle: C = !1,
    ...v
  } = t, p = Ce(
    C && `${r}switch--subtle`,
    `${r}switch`,
    u
  );
  return /* @__PURE__ */ E.jsxs("span", { className: p, children: [
    /* @__PURE__ */ E.jsx(
      "input",
      {
        id: n,
        type: "checkbox",
        name: l,
        value: s,
        className: `${r}switch__checkbox`,
        "aria-describedby": i,
        onChange: o,
        ...v
      }
    ),
    /* @__PURE__ */ E.jsx("span", { className: `${r}switch__toggle`, children: /* @__PURE__ */ E.jsx("span", { className: `${r}switch__button`, children: /* @__PURE__ */ E.jsx("span", { className: `${r}switch__symbol` }) }) }),
    d && /* @__PURE__ */ E.jsx(
      Qn,
      {
        prefix: r,
        htmlFor: n,
        label: d,
        id: i,
        className: `${r}switch__label`
      }
    )
  ] });
};
var tr = er, nr = tr;
const rr = [{ tag: "path", att: { d: "M12.0001 11.2157c1.1046 0 2-.8954 2-2s-.8954-2-2-2c-1.1045 0-2 .8954-2 2s.8955 2 2 2z" } }, { tag: "path", att: { "fill-rule": "evenodd", "clip-rule": "evenodd", d: "M12.0001 21.3736c3.7444-2.5044 7.4025-6.5319 7.4025-11.288 0-4.0031-3.4051-7.4606-7.4121-7.4606-4.0108 0-7.3928 3.4614-7.3928 7.4606 0 4.7571 3.6584 8.7823 7.4024 11.288zm-5.4024-11.288c0-2.9193 2.511-5.4606 5.3928-5.4606 2.8856 0 5.4121 2.5452 5.4121 5.4606 0 3.6054-2.69 6.7393-5.4025 8.8443-2.7125-2.105-5.4024-5.2389-5.4024-8.8443z" } }, { tag: "path", att: { d: "M14.0001 9.2157c0 1.1046-.8954 2-2 2-1.1045 0-2-.8954-2-2s.8955-2 2-2c1.1046 0 2 .8954 2 2z" } }];
var ar = () => Te(rr), ir = k(nr)(yt || (yt = D([`
  margin-top: 8px;
`], [`
  margin-top: 8px;
`]))), or = k.fieldset(St || (St = D([`
  padding: 0;
  position: relative;
  display: flex;
  flex-direction: column;
  margin-bottom: 40px;
  border: 0;
`], [`
  padding: 0;
  position: relative;
  display: flex;
  flex-direction: column;
  margin-bottom: 40px;
  border: 0;
`]))), bt = k.div(wt || (wt = D([`
  display: flex;
  flex-wrap: wrap;
  gap: 12px;
`], [`
  display: flex;
  flex-wrap: wrap;
  gap: 12px;
`]))), lr = k.span(Et || (Et = D([`
  display: flex;
  align-items: center;
  margin-top: 8px;
`], [`
  display: flex;
  align-items: center;
  margin-top: 8px;
`]))), sr = k.div(Ct || (Ct = D([`
  display: flex;
  flex-direction: column;
  margin-top: 32px;
`], [`
  display: flex;
  flex-direction: column;
  margin-top: 32px;
`]))), xt = k(ee)(Tt || (Tt = D([`
  font-size: 22px;
  font-weight: 500;
`], [`
  font-size: 22px;
  font-weight: 500;
`]))), cr = function(t) {
  var n = t.slots, r = t.selectedTimeSlot, i = t.selectTimeSlot, s = t.headerText, l = t.noAvailableTimeWindowsError, u = t.originalServiceTimeZoneTextInfo, o = t.replacementServiceTimeZoneTextInfo, d = t.replacementServiceSlots, C = t.replacementServiceSwitchLabel, v = t.replacementServiceSwitchHeading, p = t.showReplacementServiceSlots, x = t.onSwitchChange, h = t.showReplacementServiceSwitch, $ = t.storeName, L = m.useCallback(function(_) {
    i(_, !0);
  }, [i]), V = Ve();
  return m.createElement(
    or,
    { role: "group", "aria-labelledby": "timeslots-heading-".concat(V) },
    m.createElement(
      "legend",
      { id: "timeslots-heading-".concat(V) },
      m.createElement(ee, { tagName: "h3", textStyle: "Heading.S" }, s),
      n.length === 0 && m.createElement(xt, null, l),
      n.length !== 0 && u && m.createElement(ee, null, u)
    ),
    m.createElement(bt, null, n.map(function(_) {
      var y = _.id, H = _.from, q = _.to, U = _.generatedId;
      return m.createElement(mt, { key: y, id: y, generatedId: U, from: H, to: q, selected: r === y, selectTimeSlot: i });
    })),
    h && m.createElement(
      sr,
      null,
      m.createElement(ee, null, v),
      m.createElement(ir, { id: "replacement-service-switch", value: "replacement-service-switch", defaultChecked: p, onChange: function(_) {
        return x(_.target.checked);
      }, label: C })
    ),
    p && m.createElement(
      lr,
      null,
      m.createElement(Bt, { paths: ar }),
      m.createElement(ee, null, $)
    ),
    p && d.length === 0 && m.createElement(xt, null, l),
    p && d.length !== 0 && o && m.createElement(ee, null, o),
    p && d.length > 0 && m.createElement(bt, null, d == null ? void 0 : d.map(function(_) {
      var y = _.id, H = _.from, q = _.to, U = _.generatedId;
      return m.createElement(mt, { key: y, id: y, generatedId: U, from: H, to: q, selected: r === y, selectTimeSlot: L });
    }))
  );
}, yt, St, wt, Et, Ct, Tt;
const ur = [{ tag: "path", att: { "fill-rule": "evenodd", "clip-rule": "evenodd", d: "m7 12.0009 8.0012-8.0007 1.4142 1.4142-6.587 6.5866 6.5859 6.5868L15 20.002l-8-8.0011z" } }];
var dr = () => Te(ur);
const fr = [{ tag: "path", att: { "fill-rule": "evenodd", "clip-rule": "evenodd", d: "m16.415 12.0011-8.0012 8.0007-1.4141-1.4143 6.587-6.5866-6.586-6.5868L8.415 4l8 8.0011z" } }];
var pr = () => Te(fr), mr = k.div(_t || (_t = D([`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin: 0 0 16px 0;

  @media (min-width: `, `) {
    margin: 0 0 24px 0;
  }
`], [`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin: 0 0 16px 0;

  @media (min-width: `, `) {
    margin: 0 0 24px 0;
  }
`])), oe.tabletLandscapeUp), vr = function(t) {
  var n = t.firstDate, r = t.lastDate, i = t.setSpan, s = t.nextText, l = t.previousText, u = t.numberOfWeeks, o = t.onNextClick, d = t.onPrevClick, C = t.nextEnabled, v = t.prevEnabled, p = t.children, x = m.useCallback(function() {
    i(bn(r, 1).toISOString()), o && o(Wt(r, 1).toISOString());
  }, [r, o, i]), h = m.useCallback(function() {
    var $ = xn(n, u).toISOString();
    i($), d && d($);
  }, [n, u, d, i]);
  return m.createElement(
    mr,
    null,
    m.createElement(Ne, { type: "tertiary", "data-cy": "ts-picker-prev", onClick: h, disabled: !v, "aria-label": l, ssrIcon: dr, iconOnly: !0 }),
    p,
    m.createElement(Ne, { type: "tertiary", "data-cy": "ts-picker-next", onClick: x, disabled: !C, "aria-label": s, ssrIcon: pr, iconOnly: !0 })
  );
}, _t, hr = function(t) {
  if (!t || t.length === 0)
    return t;
  var n = new Date(t), r = n.getUTCFullYear(), i = n.getUTCMonth(), s = n.getUTCDate();
  return new Date(r, i, s).toISOString();
}, He = function(t, n) {
  var r = t.includes("T") && n.includes("T");
  return r ? Ee(t, n) : Ee(t, hr(n));
}, qe = function(t, n) {
  var r, i, s, l = t.find(function(u) {
    return Ee(n, u.date);
  });
  return (s = (i = (r = l == null ? void 0 : l.timeSlots) === null || r === void 0 ? void 0 : r[0]) === null || i === void 0 ? void 0 : i.id) !== null && s !== void 0 ? s : "";
}, gr = k.div($t || ($t = D([`
  display: flex;
  justify-content: space-between;
  padding: 6px 0;

  @media (min-width: `, `) {
    padding: 8px 0;
  }
`], [`
  display: flex;
  justify-content: space-between;
  padding: 6px 0;

  @media (min-width: `, `) {
    padding: 8px 0;
  }
`])), oe.tabletPortraitUp), Vt = k(Ne)(Dt || (Dt = D([`
  &&& {
    .btn__inner {
      font-size: 12px;
      font-weight: 400;
      min-height: 32px;
      min-width: 32px;
      width: 32px;
      height: 32px;
      border: 2px solid
        `, `;
      box-sizing: border-box;
      padding: 0;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      cursor: `, `;
      background: `, `;

      &:hover {
        background: `, `;
      }

      @media (min-width: `, `) {
        font-size: 14px;
        min-height: 64px;
        min-width: 64px;
        width: 64px;
        height: 64px;
      }
    }
  }
`], [`
  &&& {
    .btn__inner {
      font-size: 12px;
      font-weight: 400;
      min-height: 32px;
      min-width: 32px;
      width: 32px;
      height: 32px;
      border: 2px solid
        `, `;
      box-sizing: border-box;
      padding: 0;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      cursor: `, `;
      background: `, `;

      &:hover {
        background: `, `;
      }

      @media (min-width: `, `) {
        font-size: 14px;
        min-height: 64px;
        min-width: 64px;
        width: 64px;
        height: 64px;
      }
    }
  }
`])), function(t) {
  var n = t.disabled;
  return n ? R.interactive.default : R.interactive.borderEmphasised;
}, function(t) {
  var n = t.disabled;
  return n ? "not-allowed" : "pointer";
}, function(t) {
  var n = t.disabled;
  return n ? R.background.default : R.interactive.emphasised;
}, function(t) {
  var n = t.disabled;
  return n ? R.background.default : R.interactive.emphasisedHover;
}, oe.tabletPortraitUp), br = k(Vt)(Pt || (Pt = D([`
  &&& {
    .btn__inner {
      color: `, `;
      background: `, `;
      border: solid 2px
        `, `;

      &:hover {
        `, `
      }
    }
  }
`], [`
  &&& {
    .btn__inner {
      color: `, `;
      background: `, `;
      border: solid 2px
        `, `;

      &:hover {
        `, `
      }
    }
  }
`])), function(t) {
  var n = t.disabled;
  return n ? R.text.disabled : R.text.dark;
}, function(t) {
  var n = t.disabled;
  return n ? R.background.default : R.interactive.default;
}, function(t) {
  var n = t.$isCurrent;
  return n ? R.interactive.borderEmphasised : R.interactive.default;
}, function(t) {
  var n = t.disabled, r = t.$isCurrent;
  return !n && `
          background: `.concat(R.interactive.defaultHover, `;
          border: solid 2px `).concat(r ? R.interactive.borderEmphasised : R.interactive.defaultHover, `;
        `);
}), xr = k.span(Nt || (Nt = D([`
  position: relative;
  width: 4px;
  height: 4px;
  top: 2px;
  border-radius: 100%;

  @media (min-width: `, `) {
    width: 8px;
    height: 8px;
    top: 4px;
  }
`], [`
  position: relative;
  width: 4px;
  height: 4px;
  top: 2px;
  border-radius: 100%;

  @media (min-width: `, `) {
    width: 8px;
    height: 8px;
    top: 4px;
  }
`])), oe.tabletPortraitUp), Rt = k.div(It || (It = D([`
  display: flex;
  flex-direction: row;
  gap: 2px;
`], [`
  display: flex;
  flex-direction: row;
  gap: 2px;
`]))), kt = k(xr)(At || (At = D([`
  background: `, `;
`], [`
  background: `, `;
`])), function(t) {
  var n = t.$selected;
  return n ? R.background.default : R.static.green;
}), jt = function(t, n, r) {
  return Ft(t) ? "".concat(n, " ").concat(te(t, "EEEE dd MMMM yyyy", { locale: r })) : te(t, "EEEE dd MMMM yyyy", { locale: r });
}, yr = function(t) {
  var n = t.date, r = t.slot, i = t.selectSlot, s = t.selected, l = t.ariaTodayWord, u = t.locale, o = t.replacementServiceSlot, d = t.showReplacementServiceSlots, C = r ? r.date : "", v = o ? o == null ? void 0 : o.date : "", p = C || v, x = m.useCallback(function(h) {
    if (!(h.currentTarget.getAttribute("aria-disabled") === "true" || s)) {
      var $ = !r && !!o;
      i(p, $);
    }
  }, [i, p, o, s, r]);
  return m.createElement(m.Fragment, null, s ? m.createElement(
    Vt,
    { type: "emphasised", onClick: x, disabled: !r && !d || !r && !o, "aria-label": jt(n, l, u), "aria-pressed": s },
    te(n, "dd", { locale: u }),
    m.createElement(Rt, null, (r || o && d) && m.createElement(kt, { $selected: s }))
  ) : m.createElement(
    br,
    { type: "tertiary", $isCurrent: Ft(n), onClick: x, disabled: !r && !d || !r && !o, "aria-label": jt(n, l, u), "aria-pressed": s },
    te(n, "dd", { locale: u }),
    m.createElement(Rt, null, (r || o && d) && m.createElement(kt, { $selected: s }))
  ));
}, Ot = function(t) {
  var n = t.days, r = t.selectSlot, i = t.selectedSlot, s = t.ariaTodayWord, l = t.locale, u = t.showReplacementServiceSlots;
  return m.createElement(gr, null, n.map(function(o) {
    return m.createElement(yr, ie({ key: o.date }, o, { selected: He(o.date, i), selectSlot: r, ariaTodayWord: s, locale: l, showReplacementServiceSlots: u }));
  }));
}, $t, Dt, Pt, Nt, It, At;
const Sr = (t, n) => {
  const r = [];
  for (let i = 0; i < t.length; i += n)
    r.push(t.slice(i, i + n));
  return r;
};
var wr = 7, Er = {
  numberOfWeeks: 2,
  weekStartsOn: 1,
  slots: [],
  locale: {},
  startDate: (/* @__PURE__ */ new Date()).toISOString(),
  replacementServiceSlots: []
}, Ht = function(t) {
  var n = ie(ie({}, Er), t), r = function() {
    var o = ot(n.startDate, {
      weekStartsOn: n.weekStartsOn
    });
    return Array(n.numberOfWeeks * wr).fill(null).map(function(d, C) {
      var v = Wt(o, C).toISOString(), p = n.replacementServiceSlots.find(function(h) {
        return Ee(h.date, v);
      }), x = n.slots.find(function(h) {
        return Ee(h.date, v);
      });
      return {
        date: v,
        slot: x,
        replacementServiceSlot: p
      };
    });
  }, i = r(), s = function() {
    return i;
  }, l = function(o) {
    return Ht(ie(ie({}, n), { startDate: ot(o, {
      weekStartsOn: n.weekStartsOn
    }).toISOString() }));
  }, u = function() {
    return Array(7).fill(0).map(function(o, d) {
      return {
        name: te(i[d].date, "EEE", {
          locale: n.locale
        }),
        title: te(i[d].date, "EEEE", {
          locale: n.locale
        })
      };
    }).map(function(o) {
      return {
        name: "".concat(o.name[0].toUpperCase()).concat(o.name.substring(1)),
        title: o.title
      };
    });
  };
  return Object.freeze({
    getDays: s,
    setSpan: l,
    getWeekdays: u
  });
};
const ze = (t) => ({
  days: t.getDays(),
  weekdays: t.getWeekdays()
}), Cr = (t, n, r = {
  date: "",
  timeSlotId: ""
}) => {
  var v;
  let i = r.date || "";
  n && (i = n);
  const s = Ht({
    ...t,
    startDate: i
  }), [l, u] = Mt({
    ...ze(s),
    calendar: s,
    selectedSlot: r.date || "",
    selectedTimeSlot: r.timeSlotId
  }), o = (p) => u((x) => {
    const h = x.calendar.setSpan(p);
    return { ...x, ...ze(h), calendar: h };
  }), d = (p) => new Promise((x) => {
    u((h) => {
      const $ = qe(
        [...t.slots, ...t.replacementServiceSlots],
        p
      );
      return x({
        currentTimeSlotId: $,
        currentTimeSlot: h.selectedTimeSlot
      }), {
        ...h,
        selectedSlot: p,
        selectedTimeSlot: $
      };
    });
  }), C = (p) => new Promise((x) => {
    u((h) => {
      const $ = { ...h, selectedTimeSlot: p };
      return x({
        currentTimeSlotId: p,
        currentTimeSlot: h.selectedTimeSlot
      }), $;
    });
  });
  return gn(() => {
    var p;
    if (((p = t.replacementServiceSlots) == null ? void 0 : p.length) !== 0 && t.slots.length === 0) {
      const x = qe(
        t.replacementServiceSlots,
        t.replacementServiceSlots[0].date
      );
      u({
        ...ze(s),
        calendar: s,
        selectedSlot: t.replacementServiceSlots[0].date || "",
        selectedTimeSlot: x
      });
    }
  }, [(v = t.replacementServiceSlots) == null ? void 0 : v.length]), [l, { setSpan: o, selectSlot: d, selectTimeSlot: C }];
};
var Tr = function(t, n, r, i, s) {
  return "".concat(te(t, yn(t, n) ? i : s, {
    locale: r
  }), " - ").concat(te(n, s, { locale: r }));
}, Ye = function(t) {
  var n = t.start, r = t.end, i = t.locale, s = t.shortDateFormat, l = s === void 0 ? "dd MMM" : s, u = t.longDateFormat, o = u === void 0 ? "dd MMM yyyy" : u;
  return m.createElement(ee, { tagName: "p", textStyle: "Body.L", "data-cy": "ts-picker-title" }, Tr(n, r, i, l, o));
};
const _r = k.div`
  ${(t) => `
  display: flex;
  flex-direction: column;
  width: 100%;
  color: ${t.disabled ? R.text.default : "inherit"};
  pointer-events: ${t.disabled ? "none" : "auto"};
`}

  @media (min-width: ${oe.tabletLandscapeUp}) {
    max-width: 906px;
  }
`, Rr = k.section`
  flex-grow: 1;
  flex-shrink: 0;
  max-width: 558px;

  @media (min-width: ${oe.tabletLandscapeUp}) {
    min-width: 552px;
  }
`, kr = k.div`
  position: relative;
  margin-bottom: 40px;
`, jr = k.div`
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  font-size: 14px;
  padding: 1rem 2.5rem;
  box-sizing: border-box;
  color: ${R.text.dark};
  background: ${R.background.default};
  border: 1px solid #ccc;
  border-radius: 2px;
  width: calc(100vw - 2rem);
  max-width: 440px;
`, Lt = (t) => {
  if (t.length === 0) return;
  const n = t[0][0], r = t[t.length - 1][t[t.length - 1].length - 1];
  return {
    firstDayDate: n.date,
    lastDayDate: r.date
  };
}, Pr = ({
  title: t,
  slots: n,
  numberOfWeeks: r = 2,
  replacementServiceSlots: i = [],
  nextText: s,
  previousText: l,
  timeSlotHeaderText: u,
  ariaTodayWord: o,
  originalServiceTimeZoneTextInfo: d,
  replacementServiceTimeZoneTextInfo: C,
  preselectedSlot: v,
  onChange: p,
  onNextClick: x,
  onPrevClick: h,
  noAvailableTimeWindowsError: $,
  prevEnabled: L = !0,
  nextEnabled: V = !0,
  timeSlotsMessage: _ = null,
  locale: y,
  disabled: H,
  weekStartsOn: q = 1,
  shouldStartOn: U = "",
  shortDateFormat: ne,
  longDateFormat: K,
  replacementServiceSwitchHeading: de,
  replacementServiceSwitchLabel: B,
  replacementServiceSelectedTimeSlot: fe,
  storeName: pe
}) => {
  const X = n.map((S) => ({
    ...S,
    timeSlots: S.timeSlots.map((M) => ({
      ...M,
      generatedId: Ve()
    }))
  })), I = i.map(
    (S) => ({
      ...S,
      timeSlots: S.timeSlots.map((M) => ({
        ...M,
        generatedId: Ve()
      }))
    })
  ), [
    { days: P, weekdays: z, selectedSlot: F, selectedTimeSlot: Y },
    { selectSlot: me, selectTimeSlot: _e, setSpan: Re }
  ] = Cr(
    {
      numberOfWeeks: r,
      weekStartsOn: q,
      slots: n,
      locale: y,
      replacementServiceSlots: i
    },
    U,
    v
  ), { date: ve } = P[0], { date: he } = P[P.length - 1], { timeSlots: ke } = X.find(
    ({ date: S }) => He(S, F)
  ) || { timeSlots: [] }, { timeSlots: Ie } = (I == null ? void 0 : I.find(
    ({ date: S }) => He(S, F)
  )) || { timeSlots: [] }, ge = P.filter(({ slot: S }) => S !== void 0).length > 0 ? ke : [], le = P.some(
    ({ replacementServiceSlot: S }) => S !== void 0
  ) ? Ie : [], [J, be] = Mt(
    ge.length === 0 || !!fe
  ), re = Sr(P, 7), Oe = (S, M) => {
    v && S === v.timeSlotId && !(S === "" && (v == null ? void 0 : v.timeSlotId) === "") || _e(S).then(
      ({ currentTimeSlotId: ye }) => p({
        id: ye,
        isReplacementService: M,
        dateChanged: !1
      })
    );
  }, xe = (S, M) => {
    me(S).then(({ currentTimeSlotId: ye }) => {
      p({
        id: ye,
        dateChanged: !0,
        isReplacementService: M
      });
    });
  }, Ae = (S) => {
    S || Oe(qe(n, F)), be(S);
  }, $e = re.slice(0, 4), G = Lt($e), Z = re.slice(4, 8), se = Lt(Z);
  return /* @__PURE__ */ E.jsxs(_r, { disabled: H, children: [
    /* @__PURE__ */ E.jsxs(Rr, { children: [
      t && /* @__PURE__ */ E.jsx(ee, { tagName: "h3", textStyle: "Heading.S", children: t }),
      /* @__PURE__ */ E.jsx(
        vr,
        {
          setSpan: Re,
          firstDate: ve,
          lastDate: he,
          numberOfWeeks: r,
          nextText: s,
          previousText: l,
          onNextClick: x,
          onPrevClick: h,
          prevEnabled: L,
          nextEnabled: V,
          children: /* @__PURE__ */ E.jsx(
            Ye,
            {
              start: ve,
              end: he,
              locale: y,
              shortDateFormat: ne,
              longDateFormat: K
            }
          )
        }
      ),
      /* @__PURE__ */ E.jsx(Fn, { days: z }),
      /* @__PURE__ */ E.jsxs(kr, { children: [
        r > 4 && G && /* @__PURE__ */ E.jsx(
          Ye,
          {
            start: G.firstDayDate,
            end: G.lastDayDate,
            locale: y,
            shortDateFormat: ne,
            longDateFormat: K
          }
        ),
        $e.map((S) => /* @__PURE__ */ E.jsx(
          Ot,
          {
            days: S,
            selectedSlot: F,
            selectSlot: xe,
            ariaTodayWord: o,
            locale: y,
            showReplacementServiceSlots: J
          },
          S[0].date
        )),
        se && /* @__PURE__ */ E.jsx(
          Ye,
          {
            start: se.firstDayDate,
            end: se.lastDayDate,
            locale: y,
            shortDateFormat: ne,
            longDateFormat: K
          }
        ),
        Z.map((S) => /* @__PURE__ */ E.jsx(
          Ot,
          {
            days: S,
            selectedSlot: F,
            selectSlot: xe,
            ariaTodayWord: o,
            locale: y,
            showReplacementServiceSlots: J
          },
          S[0].date
        )),
        _ && /* @__PURE__ */ E.jsx(jr, { tabIndex: 0, role: "status", children: _ })
      ] })
    ] }),
    (ge.length > 0 || le.length > 0) && /* @__PURE__ */ E.jsx(
      cr,
      {
        showReplacementServiceSlots: J,
        onSwitchChange: Ae,
        slots: ge,
        replacementServiceSlots: le,
        selectedTimeSlot: Y,
        selectTimeSlot: Oe,
        headerText: u,
        originalServiceTimeZoneTextInfo: d,
        replacementServiceTimeZoneTextInfo: C,
        replacementServiceSwitchHeading: de,
        replacementServiceSwitchLabel: B,
        showReplacementServiceSwitch: i.length > 0,
        noAvailableTimeWindowsError: $,
        storeName: pe
      }
    )
  ] });
};
export {
  Pr as default
};
//# sourceMappingURL=ts-picker.es.js.map
